import { render } from "./CreateCompliant.vue?vue&type=template&id=d2221350"
import script from "./CreateCompliant.vue?vue&type=script&lang=js"
export * from "./CreateCompliant.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__